import { defineStore } from 'pinia';
import api from '../services/api';

export const useCategoryStore = defineStore('categories', {
  state: () => ({
    categories: [],
    loading: false,
    fetched: false
  }),
  
  actions: {
    async fetchCategories() {
      if (this.fetched) return;
      this.loading = true;
      try {
        const { data } = await api.get('/categories');
        this.categories = data;
        this.fetched = true;
      } catch (error) {
        console.error('Error fetching categories:', error);
      } finally {
        this.loading = false;
      }
    }
  }
});
